export class KitFolderFormModel {

  constructor(public name: string = '') {}
}


// WEBPACK FOOTER //
// ./src/app/services/kit-folder-form-model.ts